/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */

var Model = require("../types/Model.js");

module.exports = Model({
	name: "soundspreferences",
	init: init,
	uninit: uninit,
	triggers: triggers,
	listeners: listeners,

	_preferences: null,
	_available: null,

	test: handle_testSound

});

var DEFAULT_SOUNDS = {
	alert: "alert",
	busy: "busy",
	incoming: "incoming",
	message: "message",
	outgoing: "outgoing",
};

function init() {
	this._preferences = DEFAULT_SOUNDS;
	this.push(this._preferences);
}

function uninit() {
	this._preferences = null;
}

function triggers() {
	return {
		"test": handle_testSound
	};
}

function listeners() {
	return {
		"personal:updated": handle_personal_updated
	};
}

function handle_personal_updated(data) {
	var ringtone = data.ringtone;
	var update = {};
	if (!ringtone) ringtone = "incoming";
	update.incoming = ringtone;
	this.extend(update);
}

/**
 * These functions react to the user wanting to test out a sound before making it
 * a preference.  The Start triggers the playing of a sound with intent "test".
 * @param  {[type]} sound [description]
 * @return {[type]}       [description]
 */
function handle_testSound() {
	this.emit("sounds:trigger:play", {
		sound: "incoming"
	});
	setTimeout(testStop.bind(this), 4000);
	this.emit("usermetrics:trigger:track", "play test ringtone");
}

function testStop() {
	this.emit("sounds:trigger:stop");
}
